import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { Page } from 'modules/layout/components/Page';

import { useAdvancedApiPageStyles } from './useAdvancedApiPageStyles';

const LoadableAdvancedApi = loadable(
  async () =>
    import('./AdvancedApiPage').then(module => module.AdvancedApiPage),
  {
    fallback: <OverlaySpinner />,
  },
);

export const LoadableAdvancedApiContainer = () => {
  const { classes } = useAdvancedApiPageStyles();

  return (
    <Page classes={classes}>
      <GuardAccountPermission
        permission={AccountPermission.ChainItem}
        shouldRedirect
        shouldHideAlert
      >
        <LoadableAdvancedApi />
      </GuardAccountPermission>
    </Page>
  );
};
